import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IAccount } from '@okcargo-apps/shared-domain-ionic';
import { Observable } from 'rxjs';
import { AccountService } from '../../account/account.service';

@Component({
  selector: 'lib-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  imports: [TranslateModule, CommonModule],
})
export class CompanyInfoComponent {
  private readonly accountService = inject(AccountService);

  public account$: Observable<IAccount>;

  constructor() {
    this.account$ = this.accountService.account$;
  }
}
